import { useEffect, useState } from 'react';

import Toolbar from '@lcsc-ui/components/ToolBar';
import BaseLayout from '@lcsc-ui/layouts/baseLayout';
import ecpCurl from '@lcsc-ui/utils/ecpCurl';
import Utils from '@lcsc-ui/utils/Utils';
import Head from 'next/head';
import { NextSeo } from 'next-seo';

import ListApi from '@/apis/list';
import OpApi from '@/apis/op';
import StaticdataApi from '@/apis/staticdata';
import WwwAPI from '@/apis/www';
import Brand from '@/features/brand';

const metadata = {
  title: ' 电子元器件制造商-元器件品牌大全-立创商城',
  additionalMetaTags: [
    {
      name: 'keywords',
      content: '电子元器件制造商,元器件品牌,立创商城',
    },
    {
      name: 'description',
      content: '立创商城提供国内外3000多家电子元器件制造商产品，正品有保障，物料可追溯，下单最快4小时内发货！',
    },
  ],
};
const BrandPage = (props) => {
  const { resourceData, websiteSectionList, catalogList, headerAd, notIndexHeaderAdapter } = props;
  const [isOldCus, setIsOldCus] = useState(false); // 是否为老用户
  const [leftHeight, setLeftHeight] = useState('');
  const [isLgScreen, setIsLgScreen] = useState(null);

  useEffect(() => {
    setIsOldCus(resourceData?.commonConfigVO?.existSendOrder || false);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleResize = () => {
    setIsLgScreen(Utils.isLgScreen());
    setLeftHeight(window.innerHeight - 100);
  };

  return (
    <>
      <NextSeo title={metadata.title} additionalMetaTags={metadata.additionalMetaTags} />
      <Head>
        <link rel="canonical" href={resourceData?.projectConfigVO.lcscWwwUrl + '/brand.html'} />
        <link
          rel="preload"
          href="//static.szlcsc.com/ecp/assets/web/page/www/brand/images/brand-delete-hover-2.svg"
          as="image"
        />
        <link
          rel="preload"
          href="//static.szlcsc.com/ecp/assets/web/page/www/brand/images/search-icon-hover.svg"
          as="image"
        />
        <link
          rel="preload"
          href="//static.szlcsc.com/ecp/assets/web/page/www/brand/images/brand-big-logo.png"
          as="image"
        />
        <link
          rel="preload"
          href="//static.szlcsc.com/ecp/assets/web/page/www/brand/images/brand-small-logo.png"
          as="image"
        />
      </Head>
      <BaseLayout
        resourceData={resourceData}
        websiteSectionList={websiteSectionList}
        catalogList={catalogList}
        headerAd={headerAd}
        isLgScreen={isLgScreen}
        notIndexHeaderAdapter={notIndexHeaderAdapter}
      >
        <Brand {...props} isLgScreen={isLgScreen} leftHeight={leftHeight}></Brand>
        <Toolbar isOldCus={isOldCus}></Toolbar>
      </BaseLayout>
    </>
  );
};

export default BrandPage;

export async function getServerSideProps(context) {
  const { req } = context;
  const [
    resourceData,
    catalogList,
    websiteSectionList,
    indexAdDataList,
    brandIndexInformationData,
    brandAndCatalog,
    headerAd,
  ] = await Promise.all([
    ecpCurl(StaticdataApi.resourceList, { headers: req.headers }),
    ecpCurl(StaticdataApi.catalogList, { headers: req.headers }),
    ecpCurl(OpApi.websiteSection, { headers: req.headers }),
    ecpCurl(OpApi.advertisingbBrandList, { headers: req.headers }),
    ecpCurl(WwwAPI.brandIndexInformation, { headers: req.headers }),
    ecpCurl(ListApi.brandPageCatalog, { headers: req.headers }),
    ecpCurl(OpApi.advertisingHeader),
  ]);
  const formatBrandData = (brandDataObj) => {
    if (!brandDataObj) {
      return [];
    }
    let i = 0;
    const arr = [];
    Object.keys(brandDataObj).forEach((item) => {
      brandDataObj[item].map((v) => {
        ++i;
        v.i = i;
        return v;
      });
      arr.push({
        name: item,
        children: brandDataObj[item],
      });
    });
    return arr;
  };
  return {
    props: {
      resourceData,
      websiteSectionList,
      catalogList,
      indexAd: {
        brandList: indexAdDataList,
      },
      brandIndexInformationData,
      brandCatalogList: brandAndCatalog?.catalogList,
      brandData: formatBrandData(brandAndCatalog?.brandMap),
      headerAd,
      notIndexHeaderAdapter: true,
    },
  };
}
